export const SUPPORTED_LOCALES = ['en', 'es', 'zh', 'vi'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

export const LOCALE_STORAGE_KEY = 'ff.locale';

export const NAMESPACES = [
  'common',
  'nav',
  'auth',
  'landing',
  'iris',
  'dashboard',
  'trending',
  'settings',
  'alerts'
] as const;

export const LOCALE_LABELS: Record<SupportedLocale, string> = {
  en: 'English',
  es: 'Español',
  zh: '中文',
  vi: 'Tiếng Việt'
};

export const isSupportedLocale = (value: string): value is SupportedLocale =>
  (SUPPORTED_LOCALES as readonly string[]).includes(value);
